import Handlebars from "handlebars-template-loader/runtime";
import _ from "lodash";

/**
 * Formats number based on Localization
 */
Handlebars.registerHelper("formatNumber", number => {
  return _.numberFormat(number);
});
